var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:2px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none;}.cls-1,.cls-3,.cls-4,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-4,.cls-5{stroke:#193c34;}.cls-2{stroke-width:0px;}.cls-3{stroke:#e8ba3a;}.cls-3,.cls-5{stroke-width:4px;}.cls-6{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.81,
    y: 1.71,
    width: 236.39,
    height: 146.58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m194.53,122.41s-13.57-4.7-9.76-22.59l-8.37-12.21c-1.48-2.16-1.05-5.1.99-6.74h0c2.11-1.7,5.2-1.41,6.96.65l10.65,12.48s4.8,1.93,6.47,6.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 134.76,
    y1: 102.16,
    x2: 184.21,
    y2: 102.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m192,90.5V20.43c0-3.53-2.86-6.4-6.4-6.4h-44.45c-3.53,0-6.4,2.86-6.4,6.4v90.58c0,3.53,2.86,6.4,6.4,6.4h46.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m192,69.86h0l14.27,16.11c.61.69.95,1.58.95,2.51v48.9c0,1.18-.95,2.13-2.13,2.13h-25.43c-1.18,0-2.13-.95-2.13-2.13v-13.15c0-.6-.2-1.17-.57-1.64-.77-.98-2.09-2.92-2.54-5.17"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 134.76,
    y1: 21.92,
    x2: 192,
    y2: 21.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "144.36 48.5 144.36 34.06 158.9 34.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "144.36 58.65 144.36 73.09 158.9 73.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "183.21 48.5 183.21 34.06 168.66 34.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "183.21 58.65 183.21 73.09 168.66 73.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 151.5,
    y: 41.35,
    width: 7.47,
    height: 7.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.47,
    y: 41.35,
    width: 7.47,
    height: 7.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 151.5,
    y: 58.16,
    width: 7.47,
    height: 7.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.47,
    y: 58.16,
    width: 7.47,
    height: 7.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 134.76,
    y1: 44.12,
    x2: 192,
    y2: 44.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m72.48,113.77l-1.48,8.44c-.46,2.63,1.56,5.04,4.23,5.04h32.79c2.67,0,4.69-2.41,4.23-5.04l-1.48-8.44c-1.34-7.61-1.34-15.39,0-22.99l1.48-8.44c.46-2.63-1.56-5.04-4.23-5.04h-32.79c-2.67,0-4.69,2.41-4.23,5.04l1.48,8.44c1.34,7.61,1.34,15.39,0,22.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m72.45,77.3h-10.7c-2.67,0-4.69,2.41-4.23,5.04l1.48,8.44c1.34,7.61,1.34,15.39,0,22.99l-1.48,8.44c-.46,2.63,1.56,5.04,4.23,5.04h10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m117.3,133.39H52.46c-.97,0-1.76-.79-1.76-1.76v-2.63c0-.97.79-1.76,1.76-1.76h64.84c.97,0,1.76.79,1.76,1.76v2.63c0,.97-.79,1.76-1.76,1.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 55.75,
    y: 133.39,
    width: 11.23,
    height: 6.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.78,
    y: 133.39,
    width: 11.23,
    height: 6.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 84.4,
    y: 87.83,
    width: 14.44,
    height: 14.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 87.98,
    y: 91.36,
    width: 2.26,
    height: 2.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 93.11,
    y: 91.36,
    width: 2.26,
    height: 2.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 87.98,
    y: 96.45,
    width: 2.26,
    height: 2.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 93.11,
    y: 96.45,
    width: 2.26,
    height: 2.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 41.26,
    y: 14.6,
    width: 83.21,
    height: 53.5,
    rx: 4.3,
    ry: 4.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.8,
    y1: 27.37,
    x2: 111.93,
    y2: 27.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.8,
    y1: 36.69,
    x2: 111.93,
    y2: 36.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.8,
    y1: 46,
    x2: 111.93,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.8,
    y1: 55.32,
    x2: 92.49,
    y2: 55.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9.19,
    y1: 139.5,
    x2: 230.81,
    y2: 139.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo03);
export default __webpack_public_path__ + "static/media/logo03.d7ac94c25e41ac1452facf87f2b2ca03.svg";
export { ForwardRef as ReactComponent };